/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakesalltypes2Inputs */

const zh_learn_mistakesalltypes2 = /** @type {(inputs: Learn_Mistakesalltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部题型`)
};

const en_learn_mistakesalltypes2 = /** @type {(inputs: Learn_Mistakesalltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All types`)
};

const es_learn_mistakesalltypes2 = /** @type {(inputs: Learn_Mistakesalltypes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los tipos`)
};

/**
* | output |
* | --- |
* | "All types" |
*
* @param {Learn_Mistakesalltypes2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakesalltypes2 = /** @type {((inputs?: Learn_Mistakesalltypes2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakesalltypes2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakesalltypes2(inputs)
	if (locale === "en") return en_learn_mistakesalltypes2(inputs)
	return es_learn_mistakesalltypes2(inputs)
});
export { learn_mistakesalltypes2 as "learn_mistakesAllTypes" }